import { types } from "./actionTypes";

// creating action
export const getDashboard = (callback: any, params?: { createdAfter?: string; createdBefore?: string }) => {
  return {
    type: types.GET_DASHBOARD,
    callback,
    params,
  };
};
